/* eslint-disable no-use-before-define */
import React from 'react'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  FormGroup,
  Form,
  Label,
  Row,
  Col,
} from 'reactstrap'
import { get, set, isEmpty, toNumber } from 'lodash'
import styled from 'styled-components'
import { css } from 'styled-components'

import Typography from '../../../../lib/typography'

import { createTableCard } from '../../table/table-submit-project'
import { getDifferenceValueFormat, getDifferencePercentageFormat } from '../../../../function/math'

// const Card = createTableCard(css`
//   grid-template-columns: 25% 25% 25% 25%;
// `)
const Card = createTableCard(css`
  grid-template-columns: 30% 25% 25% 20%;
`)

const HeaderForm = styled(ModalHeader)`
  font-family: 'Gotham-Bold' !important;
  font-size: 12px ;
`
const HeadLabel = styled(Label)`
  font-family: 'Gotham-Bold' !important;
  font-size: 16px ;
  color: #AD2624;
  margin-left: 5px;
`
const TextLabel = styled(Label)`
  font-family: 'Gotham-Bold' !important;
  font-size: 14px ;
  margin-left: 5px;
`
const TextArea = styled.textarea`
  width: 100%;
`

// const profitColor = {
//   color: "#5cb85c",
// }

// const lossColor = {
//   color: "#d44b49",
// }

const TextCenter = {
  textAlign: "right",
  fontFamily: 'NotoSans',
}

class SubmitProjectForm extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (get(nextProps, 'checkSubmit') !== get(prevState, 'checkSubmit')) {
      set(tempState, 'checkSubmit', get(nextProps, 'checkSubmit'))
    }
    if (get(nextProps, 'canSeeOverallCost') !== get(prevState, 'canSeeOverallCost')) {
      set(tempState, 'canSeeOverallCost', get(nextProps, 'canSeeOverallCost'))
    }
    if (get(nextProps, 'projectByID') !== get(prevState, 'projectByID')) {
      set(tempState, 'projectByID', get(nextProps, 'projectByID'))
    }
    // if (get(nextProps, 'projectSubmit') !== get(prevState, 'projectSubmit')) {
    //   set(tempState, 'projectSubmit', get(nextProps, 'projectSubmit'))
    // }
    return tempState
  }

  getDifference = (bObject, aObject, fieldName) => {
    const aVal = get(aObject, fieldName, '0')
    const bVal = get(bObject, fieldName, '0')
    return getDifferenceValueFormat(aVal, bVal);
  }

  getDifferencePercent = (bObject, aObject, fieldName) => {
    const aVal = get(aObject, fieldName, '0')
    const bVal = get(bObject, fieldName, '0')
    return getDifferencePercentageFormat(aVal, bVal)
  }

  state = {
    checkSubmit: {},
    canSeeOverallCost: false,
  }

  toNumber = (string) => {
    return toNumber(string.replace(/,/g, ''))
  }

  render() {
    const open = get(this.props, 'open')
    const toggle = get(this.props, 'toggle')
    const handleInput = get(this.props, 'handleInput')
    return (
      /* eslint no-underscore-dangle: 0 */
      <Modal
        isOpen={open}
        toggle={() => toggle()}
        size={'lg'}
      >
        <HeaderForm toggle={() => toggle()}>
          <HeadLabel>{get(this.props, 'status')}</HeadLabel>
        </HeaderForm>
        <ModalBody>
          <Row>
            <Col sm="12">
              <Form onSubmit={(e) => e.preventDefault()}>
                <FormGroup>
                  <Container >
                    <Row style={{ marginTop: 10 }}>
                      {!isEmpty(this.state.checkSubmit) && <Card.Root>
                        <Card.Heading>
                          <Typography.Data>Title</Typography.Data>
                          {/* <Typography.Data style={ TextCenter }>Last Approved</Typography.Data> */}
                          <Typography.Data style={TextCenter}>Current Version</Typography.Data>
                          <Typography.Data style={TextCenter}>Latest Approved</Typography.Data>
                          <Typography.Data style={TextCenter}>Difference</Typography.Data>
                        </Card.Heading>
                        {this.state.canSeeOverallCost &&
                          <React.Fragment>
                            <Card.Container>
                              <Typography.Data>{'Revenue'}</Typography.Data>
                              {/* <Typography.Data style={ TextCenter }>{get(this.state.checkSubmit, 'overall.last_approved.total_cost', '0.00')}</Typography.Data> */}
                              {/* <Typography.Data style={ TextCenter }>
                              {get(this.state.checkSubmit, 'overall.last_approved.total_cost', '0.00') !== '0.00' && `(${get(this.state.checkSubmit, 'overall.diff.total_cost_percent')}%) `}
                              {`${get(this.state.checkSubmit, 'overall.present.total_cost', '0.00')}`}</Typography.Data> */}
                              <Typography.Data weight="normal" style={TextCenter}>{get(this.state.projectByID, '$standard_total_pps_overall_price', '0.00')}</Typography.Data>
                              <Typography.Data weight="normal" style={TextCenter}>{get(this.state.projectByID, 'profitSheet.$standard_total_pps_overall_price', '0.00')}</Typography.Data>
                              <Typography.Data weight="normal" style={TextCenter}>{this.getDifference(this.state.projectByID.profitSheet, this.state.projectByID, '$standard_total_pps_overall_price', '0.00')}</Typography.Data>
                            </Card.Container>
                            <Card.Container>
                              <Typography.Data>{'Total Cost'}</Typography.Data>
                              {/* <Typography.Data style={ TextCenter }>{get(this.state.checkSubmit, 'overall.last_approved.total_cost', '0.00')}</Typography.Data> */}
                              {/* <Typography.Data style={ TextCenter }>
                              {get(this.state.checkSubmit, 'overall.last_approved.total_cost', '0.00') !== '0.00' && `(${get(this.state.checkSubmit, 'overall.diff.total_cost_percent')}%) `}
                              {`${get(this.state.checkSubmit, 'overall.present.total_cost', '0.00')}`}</Typography.Data> */}
                              <Typography.Data weight="normal" style={TextCenter}>{get(this.state.projectByID, '$standard_total_pps_overall_cost', '0.00')}</Typography.Data>
                              <Typography.Data weight="normal" style={TextCenter}>{get(this.state.projectByID, 'profitSheet.$standard_total_pps_overall_cost', '0.00')}</Typography.Data>
                              <Typography.Data weight="normal" style={TextCenter}>{this.getDifference(this.state.projectByID.profitSheet, this.state.projectByID, '$standard_total_pps_overall_cost', '0.00')}</Typography.Data>
                            </Card.Container>
                            <Card.Container>
                              <Typography.Data>{'GP'}</Typography.Data>
                              {/* <Typography.Data style={ TextCenter }>{get(this.state.checkSubmit, 'overall.last_approved.gross_profit', '0.00')}</Typography.Data> */}
                              {/* <Typography.Data style={ TextCenter }>{get(this.state.checkSubmit, 'overall.last_approved.gross_profit', '0.00') !== '0.00' && `(${get(this.state.checkSubmit, 'overall.diff.gross_profit_percent')}%) `}{`${get(this.state.checkSubmit, 'overall.present.gross_profit', '0.00')}`}</Typography.Data> */}
                              <Typography.Data weight="normal" style={TextCenter}>{get(this.state.projectByID, '$standard_total_pps_overall_gross_profit', '0.00')}</Typography.Data>
                              <Typography.Data weight="normal" style={TextCenter}>{get(this.state.projectByID, 'profitSheet.$standard_total_pps_overall_gross_profit', '0.00')}</Typography.Data>
                              <Typography.Data weight="normal" style={TextCenter}>{this.getDifference(this.state.projectByID.profitSheet, this.state.projectByID, '$standard_total_pps_overall_gross_profit', '0.00')}</Typography.Data>
                            </Card.Container>
                            <Card.Container>
                              <Typography.Data>{'GP%'}</Typography.Data>
                              {/* <Typography.Data style={ TextCenter }>{get(this.state.checkSubmit, 'overall.last_approved.gross_profit', '0.00')}</Typography.Data> */}
                              {/* <Typography.Data style={ TextCenter }>{get(this.state.checkSubmit, 'overall.last_approved.gross_profit', '0.00') !== '0.00' && `(${get(this.state.checkSubmit, 'overall.diff.gross_profit_percent')}%) `}{`${get(this.state.checkSubmit, 'overall.present.gross_profit', '0.00')}`}</Typography.Data> */}
                              <Typography.Data weight="normal" style={TextCenter}>{get(this.state.projectByID, '$standard_total_pps_overall_gross_profit_ratio', '0.00')}%</Typography.Data>
                              <Typography.Data weight="normal" style={TextCenter}>{get(this.state.projectByID, 'profitSheet.$standard_total_pps_overall_gross_profit_ratio', '0.00')}%</Typography.Data>
                              <Typography.Data weight="normal" style={TextCenter}>{this.getDifferencePercent(this.state.projectByID.profitSheet, this.state.projectByID, '$standard_total_pps_overall_gross_profit', '0.00')}%</Typography.Data>
                            </Card.Container>
                          </React.Fragment>}
                        <Card.Container>
                          <Typography.Data>{'Service'}</Typography.Data>
                        </Card.Container>
                        <Card.Container nested={1}>
                          <Typography.Data weight="normal" style={{ paddingLeft: '15px' }}>{'Weighted MD'}</Typography.Data>
                          {/* <Typography.Data weight="normal" style={ TextCenter }>{get(this.state.checkSubmit, 'service.last_approved.wmd', '0.00')}</Typography.Data> */}
                          {/* <Typography.Data weight="normal" style={ TextCenter }>
                            {get(this.state.checkSubmit, 'service.last_approved.wmd', '0.00') !== '0.00' && `(${get(this.state.checkSubmit, 'service.diff.wmd_percent')}%) `}
                            {`${get(this.state.checkSubmit, 'service.present.wmd', '0.00')}`}</Typography.Data> */}
                          <Typography.Data weight="normal" style={TextCenter}>{get(this.state.projectByID, '$standard_total_pps_service_weight_man_days', '0.00')}</Typography.Data>
                          <Typography.Data weight="normal" style={TextCenter}>{get(this.state.projectByID, 'profitSheet.$standard_total_pps_service_weight_man_days', '0.00')}</Typography.Data>
                          <Typography.Data weight="normal" style={TextCenter}>{this.getDifference(this.state.projectByID.profitSheet, this.state.projectByID, '$standard_total_pps_service_weight_man_days', '0.00')}</Typography.Data>
                        </Card.Container>
                        <Card.Container nested={1}>
                          <Typography.Data weight="normal" style={{ paddingLeft: '15px' }}>{'Man Day'}</Typography.Data>
                          {/* <Typography.Data weight="normal" style={ TextCenter }>{get(this.state.checkSubmit, 'service.last_approved.md', '0.00')}</Typography.Data> */}
                          {/* <Typography.Data weight="normal" style={ TextCenter }>
                            {get(this.state.checkSubmit, 'service.last_approved.md', '0.00') !== '0.00' && `(${get(this.state.checkSubmit, 'service.diff.md_percent')}%) `}
                            {`${get(this.state.checkSubmit, 'service.present.md', '0.00')}`}</Typography.Data> */}
                          <Typography.Data weight="normal" style={TextCenter}>{get(this.state.projectByID, '$standard_total_pps_service_man_days', '0.00')}</Typography.Data>
                          <Typography.Data weight="normal" style={TextCenter}>{get(this.state.projectByID, 'profitSheet.$standard_total_pps_service_man_days', '0.00')}</Typography.Data>
                          <Typography.Data weight="normal" style={TextCenter}>{this.getDifference(this.state.projectByID.profitSheet, this.state.projectByID, '$standard_total_pps_service_man_days', '0.00')}</Typography.Data>
                        </Card.Container>
                        {this.state.canSeeOverallCost &&
                          <React.Fragment>
                            <Card.Container nested={1}>
                              <Typography.Data weight="normal" style={{ paddingLeft: '15px' }}>{'Cost'}</Typography.Data>
                              {/* <Typography.Data weight="normal" style={ TextCenter }>{get(this.state.checkSubmit, 'service.last_approved.total_cost', '0.00')}</Typography.Data> */}
                              {/* <Typography.Data weight="normal" style={ TextCenter }>
                              {get(this.state.checkSubmit, 'service.last_approved.total_cost', '0.00') !== '0.00' && `(${get(this.state.checkSubmit, 'service.diff.total_cost_percent')}%) `}
                              {`${get(this.state.checkSubmit, 'service.present.total_cost', '0.00')}`}</Typography.Data> */}
                              <Typography.Data weight="normal" style={TextCenter}>{get(this.state.projectByID, '$standard_total_pps_service_cost', '0.00')}</Typography.Data>
                              <Typography.Data weight="normal" style={TextCenter}>{get(this.state.projectByID, 'profitSheet.$standard_total_pps_service_cost', '0.00')}</Typography.Data>
                              <Typography.Data weight="normal" style={TextCenter}>{this.getDifference(this.state.projectByID.profitSheet, this.state.projectByID, '$standard_total_pps_service_cost', '0.00')}</Typography.Data>
                            </Card.Container>
                            <Card.Container nested={1}>
                              <Typography.Data weight="normal" style={{ paddingLeft: '15px' }}>{'GP'}</Typography.Data>
                              {/* <Typography.Data weight="normal" style={ TextCenter }>{get(this.state.checkSubmit, 'service.last_approved.gross_profit', '0.00')}</Typography.Data> */}
                              {/* <Typography.Data weight="normal" style={ TextCenter }>
                              {get(this.state.checkSubmit, 'service.last_approved.gross_profit', '0.00') !== '0.00' && `(${get(this.state.checkSubmit, 'service.diff.gross_profit_percent')}%) `}
                              {`${get(this.state.checkSubmit, 'service.present.gross_profit', '0.00')}`}</Typography.Data> */}
                              <Typography.Data weight="normal" style={TextCenter}>{get(this.state.projectByID, '$standard_total_pps_service_gross_profit', '0.00')}</Typography.Data>
                              <Typography.Data weight="normal" style={TextCenter}>{get(this.state.projectByID, 'profitSheet.$standard_total_pps_service_gross_profit', '0.00')}</Typography.Data>
                              <Typography.Data weight="normal" style={TextCenter}>{this.getDifference(this.state.projectByID.profitSheet, this.state.projectByID, '$standard_total_pps_service_gross_profit', '0.00')}</Typography.Data>
                            </Card.Container>
                          </React.Fragment>}
                        <Card.Container>
                          <Typography.Data>{'Other Service'}</Typography.Data>
                        </Card.Container>
                        <Card.Container nested={1}>
                          <Typography.Data weight="normal" style={{ paddingLeft: '15px' }}>{'Cost'}</Typography.Data>
                          {/* <Typography.Data weight="normal" style={ TextCenter }>{get(this.state.checkSubmit, 'other_service.last_approved.total_cost', '0.00')}</Typography.Data> */}
                          {/* <Typography.Data weight="normal" style={ TextCenter }>
                            {get(this.state.checkSubmit, 'other_service.last_approved.total_cost', '0.00') !== '0.00' && `(${get(this.state.checkSubmit, 'other_service.diff.total_cost_percent')}%) `}
                            {`${get(this.state.checkSubmit, 'other_service.present.total_cost', '0.00')}`}</Typography.Data> */}
                          <Typography.Data weight="normal" style={TextCenter}>{get(this.state.projectByID, '$total_pps_other_service_cost', '0.00')}</Typography.Data>
                          <Typography.Data weight="normal" style={TextCenter}>{get(this.state.projectByID, 'profitSheet.$total_pps_other_service_cost', '0.00')}</Typography.Data>
                          <Typography.Data weight="normal" style={TextCenter}>{this.getDifference(this.state.projectByID.profitSheet, this.state.projectByID, '$total_pps_other_service_cost', '0.00')}</Typography.Data>
                        </Card.Container>
                        <Card.Container nested={1}>
                          <Typography.Data weight="normal" style={{ paddingLeft: '15px' }}>{'GP'}</Typography.Data>
                          {/* <Typography.Data weight="normal" style={ TextCenter }>{get(this.state.checkSubmit, 'other_service.last_approved.gross_profit', '0.00')}</Typography.Data> */}
                          {/* <Typography.Data weight="normal" style={ TextCenter }>
                            {get(this.state.checkSubmit, 'other_service.last_approved.gross_profit', '0.00') !== '0.00' && `(${get(this.state.checkSubmit, 'other_service.diff.gross_profit_percent')}%) `}
                            {`${get(this.state.checkSubmit, 'other_service.present.gross_profit', '0.00')}`}</Typography.Data> */}
                          <Typography.Data weight="normal" style={TextCenter}>{get(this.state.projectByID, '$total_pps_other_service_gross_profit', '0.00')}</Typography.Data>
                          <Typography.Data weight="normal" style={TextCenter}>{get(this.state.projectByID, 'profitSheet.$total_pps_other_service_gross_profit', '0.00')}</Typography.Data>
                          <Typography.Data weight="normal" style={TextCenter}>{this.getDifference(this.state.projectByID.profitSheet, this.state.projectByID, '$total_pps_other_service_gross_profit', '0.00')}</Typography.Data>
                        </Card.Container>
                        <Card.Container>
                          <Typography.Data>{'License/MA'}</Typography.Data>
                        </Card.Container>
                        <Card.Container nested={1}>
                          <Typography.Data weight="normal" style={{ paddingLeft: '15px' }}>{'Cost'}</Typography.Data>
                          {/* <Typography.Data weight="normal" style={ TextCenter }>{get(this.state.checkSubmit, 'license.last_approved.total_cost', '0.00')}</Typography.Data> */}
                          {/* <Typography.Data weight="normal" style={ TextCenter }>
                            {get(this.state.checkSubmit, 'license.last_approved.total_cost', '0.00') !== '0.00' && `(${get(this.state.checkSubmit, 'license.diff.total_cost_percent')}%) `}
                            {`${get(this.state.checkSubmit, 'license.present.total_cost', '0.00')}`}</Typography.Data> */}
                          <Typography.Data weight="normal" style={TextCenter}>{get(this.state.projectByID, '$total_pps_licenses_cost', '0.00')}</Typography.Data>
                          <Typography.Data weight="normal" style={TextCenter}>{get(this.state.projectByID, 'profitSheet.$total_pps_licenses_cost', '0.00')}</Typography.Data>
                          <Typography.Data weight="normal" style={TextCenter}>{this.getDifference(this.state.projectByID.profitSheet, this.state.projectByID, '$total_pps_licenses_cost', '0.00')}</Typography.Data>
                        </Card.Container>
                        <Card.Container nested={1}>
                          <Typography.Data weight="normal" style={{ paddingLeft: '15px' }}>{'GP'}</Typography.Data>
                          {/* <Typography.Data weight="normal" style={ TextCenter }>{get(this.state.checkSubmit, 'license.last_approved.gross_profit', '0.00')}</Typography.Data> */}
                          {/* <Typography.Data weight="normal" style={ TextCenter }>
                            {get(this.state.checkSubmit, 'license.last_approved.gross_profit', '0.00') !== '0.00' && `(${get(this.state.checkSubmit, 'license.diff.gross_profit_percent')}%) `}
                            {`${get(this.state.checkSubmit, 'license.present.gross_profit', '0.00')}`}</Typography.Data> */}
                          <Typography.Data weight="normal" style={TextCenter}>{get(this.state.projectByID, '$total_pps_licenses_gross_profit', '0.00')}</Typography.Data>
                          <Typography.Data weight="normal" style={TextCenter}>{get(this.state.projectByID, 'profitSheet.$total_pps_licenses_gross_profit', '0.00')}</Typography.Data>
                          <Typography.Data weight="normal" style={TextCenter}>{this.getDifference(this.state.projectByID.profitSheet, this.state.projectByID, '$total_pps_licenses_gross_profit', '0.00')}</Typography.Data>
                        </Card.Container>
                        <Card.Container>
                          <Typography.Data>{'Hardware'}</Typography.Data>
                        </Card.Container>
                        <Card.Container nested={1}>
                          <Typography.Data weight="normal" style={{ paddingLeft: '15px' }}>{'Cost'}</Typography.Data>
                          {/* <Typography.Data weight="normal" style={ TextCenter }>{get(this.state.checkSubmit, 'hardware.last_approved.total_cost', '0.00')}</Typography.Data> */}
                          {/* <Typography.Data weight="normal" style={ TextCenter }>
                            {get(this.state.checkSubmit, 'hardware.last_approved.total_cost', '0.00') !== '0.00' && `(${get(this.state.checkSubmit, 'hardware.diff.total_cost_percent')}%) `}
                            {`${get(this.state.checkSubmit, 'hardware.present.total_cost', '0.00')}`}</Typography.Data> */}
                          <Typography.Data weight="normal" style={TextCenter}>{get(this.state.projectByID, '$total_pps_hardwares_cost', '0.00')}</Typography.Data>
                          <Typography.Data weight="normal" style={TextCenter}>{get(this.state.projectByID, 'profitSheet.$total_pps_hardwares_cost', '0.00')}</Typography.Data>
                          <Typography.Data weight="normal" style={TextCenter}>{this.getDifference(this.state.projectByID.profitSheet, this.state.projectByID, '$total_pps_hardwares_cost', '0.00')}</Typography.Data>
                        </Card.Container>
                        <Card.Container nested={1}>
                          <Typography.Data weight="normal" style={{ paddingLeft: '15px' }}>{'GP'}</Typography.Data>
                          {/* <Typography.Data weight="normal" style={ TextCenter }>{get(this.state.checkSubmit, 'hardware.last_approved.gross_profit', '0.00')}</Typography.Data> */}
                          {/* <Typography.Data weight="normal" style={ TextCenter }>
                            {get(this.state.checkSubmit, 'hardware.last_approved.gross_profit', '0.00') !== '0.00' && `(${get(this.state.checkSubmit, 'hardware.diff.gross_profit_percent')}%) `}
                            {`${get(this.state.checkSubmit, 'hardware.present.gross_profit', '0.00')}`}</Typography.Data> */}
                          <Typography.Data weight="normal" style={TextCenter}>{get(this.state.projectByID, '$total_pps_hardwares_gross_profit', '0.00')}</Typography.Data>
                          <Typography.Data weight="normal" style={TextCenter}>{get(this.state.projectByID, 'profitSheet.$total_pps_hardwares_gross_profit', '0.00')}</Typography.Data>
                          <Typography.Data weight="normal" style={TextCenter}>{this.getDifference(this.state.projectByID.profitSheet, this.state.projectByID, '$total_pps_hardwares_gross_profit', '0.00')}</Typography.Data>
                        </Card.Container>
                        <Card.Container>
                          <Typography.Data>{'Other Cost'}</Typography.Data>
                        </Card.Container>
                        <Card.Container nested={1}>
                          <Typography.Data weight="normal" style={{ paddingLeft: '15px' }}>{'Cost'}</Typography.Data>
                          {/* <Typography.Data weight="normal" style={ TextCenter }>{get(this.state.checkSubmit, 'other_cost.last_approved.total_cost', '0.00')}</Typography.Data> */}
                          {/* <Typography.Data weight="normal" style={ TextCenter }>
                            {get(this.state.checkSubmit, 'other_cost.last_approved.total_cost', '0.00') !== '0.00' && `(${get(this.state.checkSubmit, 'other_cost.diff.total_cost_percent')}%) `}
                            {`${get(this.state.checkSubmit, 'other_cost.present.total_cost', '0.00')}`}</Typography.Data> */}
                          <Typography.Data weight="normal" style={TextCenter}>{get(this.state.projectByID, '$total_pps_other_cost', '0.00')}</Typography.Data>
                          <Typography.Data weight="normal" style={TextCenter}>{get(this.state.projectByID, 'profitSheet.$total_pps_other_cost', '0.00')}</Typography.Data>
                          <Typography.Data weight="normal" style={TextCenter}>{this.getDifference(this.state.projectByID.profitSheet, this.state.projectByID, '$total_pps_other_cost', '0.00')}</Typography.Data>
                        </Card.Container>
                      </Card.Root>}
                    </Row>
                    <Row style={{ marginTop: 40 }}>
                      <Col sm={4}>
                        <TextLabel >Remark (Max 500 Character)</TextLabel>
                      </Col>
                      <Col sm={8}>
                        <TextArea
                          name="submit_remark"
                          onBlur={(e) => handleInput(e)}
                        />
                      </Col>
                    </Row>
                  </Container>
                </FormGroup>
              </Form>
              {/* <Form onSubmit={ (e) => e.preventDefault() }>
                <FormGroup>
                  <Container >
                    <Row style={ { marginTop: 10 } }>
                      <Col sm={ 4 }>
                        <TextLabel >Remarks (Optional)</TextLabel>
                      </Col>
                      <Col sm={ 8 }>
                        <InputField
                          name="submit_remark"
                          onBlur={ (e) => handleInput(e) }
                        />
                      </Col>
                    </Row>
                  </Container>
                </FormGroup> */}
              {/* </Form> */}
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          {get(this.props, 'button')}
        </ModalFooter>
      </Modal>
    )
  }
}

export default SubmitProjectForm



// WEBPACK FOOTER //
// ./src/components/project-information/form/submit-project/index.js